<template>
  <div>
    <div class="workplace-contact-us">
      <h3 class="text-center">Contact us!</h3>

      <p class="error-message text-center" v-show="serverErrors">
        Unable to deliver message.
      </p>
      <p class="text-center" v-show="!serverErrors && !showThankyou">
        {{ description }}
      </p>
      <p class="text-center" v-show="!serverErrors && showThankyou">
        {{ thankyouMessage }}
      </p>

      <div class="wwf-form light">
        <div class="flip-wrapper" :class="{ 'formValidation-shake': isShake }">
          <div class="form-grid">
            <label
              >First name<span class="required">*</span>
              <input
                name="firstName"
                type="text"
                v-model="firstName"
                v-validate="'required'"
                :class="{ 'border-red': errors.has('firstName') }"
              />
            </label>
            <label
              >Last name<span class="required">*</span>
              <input
                name="lastName"
                type="text"
                v-model="lastName"
                v-validate="'required'"
                :class="{ 'border-red': errors.has('lastName') }"
              />
            </label>
            <label
              >Email<span class="required">*</span>
              <input
                name="emailAddress"
                type="email"
                v-model="emailAddress"
                v-validate="'required|email'"
                :class="{ 'border-red': errors.has('emailAddress') }"
              />
            </label>
            <label
              >Phone
              <input 
                name="phone" 
                type="tel" 
                v-model="phone"
                v-validate="{ phoneNumberIsValid: true }"
                :class="{ 'border-red': errors.has('phone') }"
              />
            </label>
            <label class="span-fw"
              >Message<span class="required">*</span>
              <textarea
                name="message"
                type="text"
                v-model="message"
                v-validate="'required'"
                :class="{ 'border-red': errors.has('message') }"
              ></textarea>
            </label>
          </div>

          <p>Mandatory field(s) marked with *</p>
          <input
            class="submit-btn"
            type="button"
            v-on:click="postTicket"
            value="Submit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import gtm from '../../utils/gtm';

export default {
  name: "WorkplaceContactUs",

  data() {
    return {
      isShake: false,
      serverErrors: false,
      firstName: "",
      lastName: "",
      emailAddress: "",
      phone: "",
      message: "",
      isLoading: false,
      showThankyou: false,
    };
  },
  props: {
    description: {
      type: String,
      default:
        "Do you have any questions about workplace giving? Contact us and we’ll get back to you.",
    },
    thankyouMessage: {
      type: String,
      default:
        "Thank you for your enquiry. We will be in touch with you very soon.",
    },
    subjectLine: {
      type: String,
      default: "Workplace giving for employers",
    },
  },
  
  created() {
   // Check Phone Number
    let phoneNumberIsValid = (phoneNumber) => {
      if (phoneNumber) {
        const validationRegex = /^(\+?61|0)([0-9]{8,9})$/;
        if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
          return {
            valid: false,
            data: { message: "Invalid phone number" },
          };
        } else {
          return {
            valid: true,
          };
        }
      } else {
        return {
          valid: true,
        };
      }
    };

    Validator.extend("phoneNumberIsValid", {
      validate: phoneNumberIsValid,
      getMessage: (field, params, data) => data.message,
    });
  },

  methods: {
    postTicket: function () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (!this.isLoading) {
            this.isLoading = true;

            // Generate a token for a special action
            await this.$store.dispatch("generateCaptchaToken", "contactUsWorkplace");

            // Enquiry will be sent to sek@wwf.org.au
            this.$http
              .post(wwfconfigs.WEB_API + "/contact/workplace", {
                subject: this.subjectLine,
                emailAddress: this.emailAddress,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                message: this.message,
              })
              .then((response) => {
                console.log(response);
                this.resetForm();
                this.showThankyou = true;
                this.serverErrors = false;
                this.isLoading = false;
                // Push to datalayer
                gtm.formSubmitSuccessEvent('Workplace contact us Form');
              })
              .catch((err) => {
                console.error(err);
                this.serverErrors = true;
                this.isLoading = false;
              });
          }
        } else {
          this.isShake = true;
          setTimeout(
            function () {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
    resetForm: function () {
      this.firstName = "";
      this.lastName = "";
      this.emailAddress = "";
      this.phone = "";
      this.message = "";
    },
  },
};
</script>

<style scoped>
.workplace-contact-us,
.wwf-form .flip-wrapper {
  background: white;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 1rem;
}

.span-fw {
  grid-column: 1 / -1;
}

.required {
  color: rgb(164, 0, 0);
}

.workplace-contact-us .wwf-form .submit-btn {
  text-transform: capitalize;
}

.error-message {
  color: var(--errorColor);
}

@media only screen and (max-width: 64em) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// WorkplaceContactUs.vue?2e975c40